var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view-referral-kpis"},_vm._l((_vm.dataset),function(kpi,i){return _c('data-stat',_vm._b({key:i},'data-stat',kpi,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }